import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FaArrowUp } from "react-icons/fa";

const FooterContainer = styled.footer`
  margin-top: 80px;
  padding: 60px 64px 80px;
  background: rgba(0, 0, 0, 0.85);
  border-top: 1px solid var(--ink-10);

  @media (max-width: 900px) {
    padding: 50px 28px 70px;
  }

  @media (max-width: 480px) {
    padding: 40px 5vw 60px;
    margin-top: 40px;
  }
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 40px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const FooterTitle = styled.h4`
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 12px;
  margin-bottom: 16px;
  color: var(--muted);
`;

const FooterLink = styled(Link)`
  display: block;
  margin-bottom: 10px;
  color: var(--ink);
  opacity: 0.78;
  font-size: 14px;
  transition: opacity 0.2s ease, color 0.2s ease;

  &:hover {
    color: var(--accent);
    opacity: 1;
  }
`;

const FooterExternalLink = styled.a`
  display: block;
  margin-bottom: 10px;
  color: var(--ink);
  opacity: 0.78;
  font-size: 14px;
  transition: opacity 0.2s ease, color 0.2s ease;

  &:hover {
    color: var(--accent);
    opacity: 1;
  }
`;

const FooterText = styled.p`
  font-size: 14px;
  color: var(--muted);
  line-height: 1.6;
`;


const Copyright = styled.div`
  margin-top: 40px;
  font-size: 12px;
  color: var(--muted);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

const BackToTopButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  color: var(--ink);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, border 0.2s ease, background 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(214, 179, 106, 0.6);
    background: rgba(214, 179, 106, 0.1);
  }
`;

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <FooterContainer>
      <FooterGrid>
        <div>
          <FooterTitle>Regime Music Societe</FooterTitle>
          <FooterText>
            A global artist services and publishing company based in Atlanta.
            We craft original compositions, build cultural moments, and move
            music across the world.
          </FooterText>
        </div>
        <div>
          <FooterTitle>Company</FooterTitle>
          <FooterLink to="/about">About RMS</FooterLink>
          <FooterLink to="/music">Catalog</FooterLink>
          <FooterLink to="/contact#publishing">Publishing inquiries</FooterLink>
          <FooterLink to="/contact#partnerships">Brand partnerships</FooterLink>
        </div>
        <div>
          <FooterTitle>Connect</FooterTitle>
          <FooterText>
            For sync, catalog, publishing, and creative inquiries, contact the RMS team directly.
          </FooterText>
          <FooterExternalLink href="mailto:efe@rmsociete.com">efe@rmsociete.com</FooterExternalLink>
          <FooterExternalLink href="tel:+14047364228">+1 (404) 736-4228</FooterExternalLink>
          {/* Social icons hidden until real RMS account URLs are provided */}
        </div>
      </FooterGrid>
      <Copyright>
        <span>© 2026 Regime Music Societe. All rights reserved.</span>
        <BackToTopButton onClick={scrollToTop} aria-label="Back to top">
          <FaArrowUp />
        </BackToTopButton>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
